import {getTemplateDefinition} from "../data/template-catalog";
import {validateGridDocument, type GridDocument, type BannerInstance} from "./document";
import {fail} from "./schema";

export const GRID_RENDER_MAX_PIXELS = 50_000_000;
export const GRID_RENDER_BATCH_PIXELS = 12_000_000; // 48M device pixels at the existing 2x SSAA.
export const GRID_RENDER_MAX_BYTES = 64 * 1024 * 1024;
export class GridRenderLimitError extends Error {}
export function createGridRenderPlan(document: GridDocument, instanceIds?: string[]) {
  validateGridDocument(document);
  if (instanceIds !== undefined) {
    if (!Array.isArray(instanceIds) || new Set(instanceIds).size !== instanceIds.length) fail("instanceIds", "Expected unique instance IDs");
    for (const id of instanceIds) if (!document.banners.some((banner) => banner.instanceId === id)) fail("instanceIds", `Unknown banner: ${id}`);
  }
  const selected = document.banners.filter((banner) => instanceIds === undefined ? banner.exportEnabled : instanceIds.includes(banner.instanceId));
  if (!selected.length) fail("instanceIds", "Select at least one banner for export");
  const pixels = selected.reduce((total, banner) => {const t = getTemplateDefinition(banner.templateKey); return total + t.width * t.height;}, 0);
  if (pixels > GRID_RENDER_MAX_PIXELS) throw new GridRenderLimitError("Grid export exceeds 50 million pixels; export fewer banners");
  const batches: BannerInstance[][] = [];
  let batch: BannerInstance[] = [], width = 0, height = 0;
  for (const banner of selected) {
    const size = getTemplateDefinition(banner.templateKey);
    if (size.width * size.height > GRID_RENDER_BATCH_PIXELS) throw new GridRenderLimitError(`Template ${banner.templateKey} exceeds the render batch budget`);
    const nextWidth = Math.max(width, size.width), nextHeight = height + size.height;
    if (batch.length && nextWidth * nextHeight > GRID_RENDER_BATCH_PIXELS) {
      batches.push(batch); batch = []; width = 0; height = 0;
    }
    batch.push(banner); width = Math.max(width, size.width); height += size.height;
  }
  if (batch.length) batches.push(batch);
  return {selected, batches, pixels};
}

export type GridRenderedBanner = {instanceId: string; templateKey: string; width: number; height: number; png: Uint8Array; pdfPng?: Uint8Array};
